// Vuex user module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  details: {
    record: null,
    total: 0,
  },
  recordsCart: [],
};

const getters = {
  details: state => state.details,
  recordsCart: state => state.recordsCart,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
